import LaporanIndividual from '../../../views/Akademi/LaporanIndividual/LaporanIndividual.view.js';

export default LaporanIndividual;
